/**
 * @file 路由配置
 */


const financial = {
    path: 'financial',
    name: 'financial',
    meta: {
        requiresAuth: true,
        label: '项目融资意向单'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/order/financial')));
    }
};

const letter = {
    path: 'letter',
    name: 'letter',
    meta: {
        label: '保函意向单'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/order/letter')));
    }
};
const mall = {
    path: 'mall',
    name: 'mall',
    meta: {
        label: '数据商城意向单'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/order/mall')));
    }
};

const list = {
    path: 'order-list',
    name: 'order-list',
    meta: {
        label: '订单列表'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/order/order-list')));
    }
};

export default {
    path: '/order',
    name: 'order',
    redirect: '/order/letter',
    icon: 'el-icon-s-custom',
    meta: {
        requiresAuth: true,
        label: '订单管理'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/order')));
    },
    children: [letter, mall, financial, list]
};
